import React, { FC, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { RadioButton } from 'primereact/radiobutton';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@/components';

import styles from './ModalDetails.module.scss';

type ModalDetailsProps = {
  oid: number;
  isDialogShown: boolean;
  toggleDialog: () => void;
};

type ClientOption = {
  key: string;
  value: string;
};

const ModalDetailSelectFavClient: FC<ModalDetailsProps> = ({
  oid,
  isDialogShown,
  toggleDialog,
}) => {
  const { t } = useTranslation('depo20');
  const [selectedClient, setSelectedClient] = useState<string | null>(null);

  const dialogHeader = (
    <div className={`${styles.header} text-blue-800`}>
      <FontAwesomeIcon
        icon={faStar}
        style={{ marginRight: '0.5rem' }}
        className="mr-3"
      />
      {t('selectFavoriteClientTitle')}
    </div>
  );

  const data: ClientOption[] = [
    { key: 'Ninguno', value: '' },
    { key: '111111111', value: ' Lorem Ipsum' },
    { key: '111111112', value: ' Lorem Ipsum' },
    { key: '111111113', value: ' Lorem Ipsum' },
    { key: '111111114', value: 'Lorem Ipsum' },
  ];

  const handleClientSelectionChange = (key: string) => {
    setSelectedClient(key);
  };

  const handleSubmit = () => {
    // eslint-disable-next-line no-console
    console.log('submit', toggleDialog, oid);
  };

  return (
    <Dialog
      header={dialogHeader}
      visible={isDialogShown}
      style={{ maxWidth: '480px' }}
      onHide={toggleDialog}
      modal
    >
      <div className="p-4">
        <div className="mb-4">{t('favoriteClientDescription')}</div>
        <form onSubmit={handleSubmit}>
          <ul className={`list-none p-0 m-0 ${styles.list}`}>
            {data.map((client) => (
              <div
                key={client.key}
                className={`${styles.clientList} ${styles.favoriteClient} `}
              >
                <hr className={styles.topDivider} />

                <li className="flex justify-content-start  align-items-center">
                  <RadioButton
                    inputId={client.key}
                    name="favoriteClient"
                    value={client.key}
                    onChange={() => handleClientSelectionChange(client.key)}
                    checked={selectedClient === client.key}
                  />
                  <label htmlFor={client.key} className="ml-4">
                    {client.key} <br />
                    <span className="font-12">{client.value}</span>
                  </label>
                </li>
                <hr />
              </div>
            ))}
          </ul>
          <div className="flex justify-content-end">
            <Button
              label={t('selectButton')}
              className={`${styles.selectButton} flex justify-content-end`}
              type="submit"
            />
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default ModalDetailSelectFavClient;
